import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from 'react-router-dom';
import Layout from "../layout"
import { realtyGetObjects, selectObjectsList } from "../../redux/modules/realty";

const RealtyDetail = () => {
    const dispatch = useDispatch();
    let { detail } = useParams();
    const auth = useSelector(state => state.auth);
    const objects = useSelector(state => state.realty.objects);
    const mobile = useSelector(state => state.mobile);
    
    const result = useSelector(state => selectObjectsList(state));

    const object = result && result.filter((item) => item.id == detail)[0];

    useEffect(() => {
        document.title = `Квартира | Личный кабинет Брокера THE FIVE`;

        if(!objects) {
            dispatch(
                realtyGetObjects({
                  cmd: 'orders-list',
                  _debug_token: auth.token
                })
            )
        }
        
    }, []);

    console.log('detail', detail)
    console.log('objects', objects)
    console.log('object', object)

    return (
        <Layout>
            <div class="breadcrumbs">
                <Link to="/realty">Назад к списку</Link>
            </div>
            {object && <div className="realty-detail">
                <div className="realty-detail__left">
                    <div className="realty-detail__title">{object.rooms === 'СТ' ? 'СТУДИЯ' : object.rooms + ' комнатная'}, {object.area} м²</div>
                    <div className="realty-detail__price">
                        <span>{new Intl.NumberFormat("ru-RU").format(Math.round(object.totalCost))} ₽</span> 
                        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="22" viewBox="0 0 7 22" fill="none">
                            <path d="M6.17578 1.33984L0.9994 20.6584" stroke="#2D2D2C" stroke-linecap="square"/>
                        </svg>
                        {new Intl.NumberFormat("ru-RU").format(Math.round(object.price))} ₽/м²
                    </div>
                    <div className="realty-detail__about-project">
                        <div className="realty-detail__about-project__image"></div>
                        <div className="realty-detail__about-project__desc">
                            <div className="realty-detail__about-project__title">{object.project}</div>
                            <div className="realty-detail__about-project__text">Срок сдачи {object.readyDate}</div>
                        </div>
                    </div>                
                    <div className="realty-detail__params">
                        <div>
                            <div>Номер</div>
                            <div>№{object.number}</div>
                        </div>
                        <div>
                            <div>Корпус</div>
                            <div>{object.building}</div>
                        </div>
                        <div>
                            <div>Секция</div>
                            <div>{object.section}</div>
                        </div>
                        <div>
                            <div>Этаж</div>
                            <div>{object.floor} из 20</div>
                        </div>
                        <div>
                            <div>Комнат</div>
                            <div>{object.rooms}</div>
                        </div>
                        <div>
                            <div>Площадь</div>
                            <div>{object.area} м²</div>
                        </div>
                        <div>
                            <div>Отделка</div>
                            <div>{object.decoration}</div>
                        </div>
                        <div>
                            <div>Высота потолка</div>
                            <div>{object.ceilingHeight} м</div>
                        </div>
                        <div>
                            <div>Стороны света</div>
                            <div>{object.views}</div>
                        </div>
                        <div>
                            <div>Вид</div>
                            <div>{object.compass}</div>
                        </div>
                    </div>
                    <div className="realty-detail__benefits">
                        {object.advantages.map((item) => <div className="realty-detail__benefits__item">{item}</div>)}
                    </div>
                    <div className="realty-detail__buttons">
                        <button className="btn">Сформировать PDF</button>
                        <button className="btn btn_empty">Отправить по e-mail</button>
                    </div>
                </div>
                <div className="realty-detail__right">
                    <div className="realty-detail__gallery">

                    </div>
                </div>
            </div>}
        </Layout>
    )
}

export default RealtyDetail